import { useEffect, useState } from "react";
import Profile from "../components/userProfile/userProfile";
import UploadProfileImage from "../components/UploadProfileImage/UploadProfileImage";
import useAPI from "../hooks/useAPI";

export default function Dashboard() {
  const [headers, setHeaders] = useState({});
  const api = useAPI();
  useEffect(() => {
    async function go() {
      const res = await api.get("/api/headers");
      setHeaders(res);
    }
    go();
  }, [api]);

  return (
    <div>
      <Profile />
      <UploadProfileImage />
      <div style={{
        maxWidth: "400px",
        textAlign: "left",
        textWrap: "wrap",
        textOverflow: "ellipsis"
      }}>
        <table>
          <thead>
            <tr>
              <th>Key</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(headers).map(([key, val]) => (
              <tr key={`headers-${key}`}>
                <td>{key}</td>
                <td>{val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
